import { Injectable } from '@angular/core';
import { Action, State, Store } from '@ngxs/store';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatActions from '@medsurf/flat-actions';
import { ApiControlService } from '@medsurf/flat-services';
import * as FlatStates from '../../internal';


@State<object>({
  name: 'pageControl'
})
@Injectable()
export class PageControlState {
  public constructor(public store: Store,
                     public apiControlService: ApiControlService) {
  }
  
  //<editor-fold desc="Selectors">
  
  //</editor-fold>

  //<editor-fold desc="Actions">

  @Action(FlatActions.PageControlActions.GetPageByCurrentRoute)
  public getPageByCurrentRoute() {
    const currentSelectedPage = this.store.selectSnapshot(FlatStates.PageEntityState.currentSelectedPage$);
    if (!currentSelectedPage) {
      const pageSlug = this.store.selectSnapshot(FlatStates.NavigationControlState.pageSlug$);
      if (!pageSlug) {
        throw new FlatModels.ErrorControlModels.MedsurfError(
          'notification.page_not_found',
          FlatModels.ErrorControlModels.ErrorLevel.enum.error,
          FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
          "LIBS.FlatStates.PageControlState.getPageByCurrentRoute"
        );
      }
      return this.apiControlService.sendMessage(
        new FlatActions.PageControlActions.GetPageByTitleRequest(pageSlug)
      );
    }
    return;
  }

  //</editor-fold>
}
